import { render, staticRenderFns } from "./kabupaten.vue?vue&type=template&id=c0dbdcde&"
import script from "./kabupaten.vue?vue&type=script&lang=js&"
export * from "./kabupaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports